/**
 * registered-bureaux
 *
 * @author    Richard J. Turner <richard.turner@mediatel.co.uk>
 * @copyright 2015 Mediatel Limited.
 */
"use strict";

import "babel-polyfill";
import coreFactory from "./common/core";
import sandboxFactory from "./common/sandbox";

// Modules
import registeredBureaux from "./resources/registered-bureaux";

const core = coreFactory(window.jQuery, sandboxFactory);

core.createModule("registered_bureaux", registeredBureaux);

core.startAll();
